// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui-data-modal-VxrYem .semi-modal-content{background-color:rgba(var(--trebox-bg-2),var(--trebox-bg-2-alpha))}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-data-modal": `ui-data-modal-VxrYem`,
	"uiDataModal": `ui-data-modal-VxrYem`
};
export default ___CSS_LOADER_EXPORT___;
